// @flow

// Effect Managers
import { fork } from 'redux-saga/effects'

// Sagas
import watchAssetMigrateOperations from './operations'
import { watchOperations } from 'hfty-operator-asset-migrate'
import operations$ from '../selectors/operations'

export default function *main (): Generator<*, *, *> {
  yield fork(watchOperations, { operations$ })
  yield fork(watchAssetMigrateOperations)
}

